// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + (chunkId === 639 ? "benefits" : chunkId) + "." + {"232":"37b6ece5","639":"19c6dadf"}[chunkId] + ".chunk.css";
};